import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaLinkedin,
  FaGithub,
  FaInstagram,
  FaEnvelope,
  FaPhoneAlt,
  FaYoutube,
  FaStackOverflow
} from "react-icons/fa";
import {
  socialMediaLinks,
  contactInfo,
  copyrightText,
} from "../config";
import { usePopularCourses } from "../context/PopularCourseContext";
import SocialIconButton from "../components/SocialIconButton";
import ScrollToTopButton from "../components/ScrollToTopButton";
import BlogPreviewList from "./BlogPreviewList";
import CookieModal from "./CookieModal"; // <- dein Modal
import { useZenTitles } from "../hooks/useZenTitles";

import { useCaseTitles } from "../hooks/useCaseTitles";

const truncateTitle = (text, maxLength = 60) => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  const truncated = text.substr(0, maxLength);
  return truncated.substr(0, truncated.lastIndexOf(" ")) + " …";
};

function Footer() {
  const popularCoursesContext = usePopularCourses();



  const [showMiniFooter, setShowMiniFooter] = useState(false);
  const footerRef = useRef(null);

  // CookieModal State & Handler
  const [showCookieModal, setShowCookieModal] = useState(false);

  // Ref für das Modal, wegen forwardRef!
  const cookieModalRef = useRef(null);

  const onShowCookieSettings = useCallback(() => setShowCookieModal(true), []);
  const onCloseCookieSettings = useCallback(() => setShowCookieModal(false), []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowMiniFooter(!entry.isIntersecting);
      },
      { threshold: 0.0 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Cookie Consent ggf. aus localStorage laden (optional)
  // const [cookieConsent, setCookieConsent] = useState(null);

  return (
    <>
      {/* Mini-Footer */}
      {showMiniFooter && (
        <div className="fixed bottom-0 left-0 right-0 
          bg-gradient-to-br from-gray-100 via-white to-gray-100 border-t border-gray-200
          shadow-slate-100 shadow-md z-30 py-4 flex flex-col items-center justify-center text-xs font-mono text-gray-800 md:flex-row md:justify-between md:px-6 md:py-2"
        >
          <div className="hidden font-bold pl-5 md:block ">Denis Bitter
            <span className="text-xs font-normal"> Software Architect & Full-Stack Engineering Instructor</span> </div>
          <div className="text-center ">
            <span className="font-mono block sm:hidden">Software Architect & Full-Stack Engineering Instructor</span>
          </div>
          <div className="mt-0 sm:mt-0 flex text-gray-800 space-x-4 hidden md:flex">
            <SocialIconButton href={socialMediaLinks.linkedin} Icon={FaLinkedin} />
            <SocialIconButton href={socialMediaLinks.youtube} Icon={FaYoutube} />
            <SocialIconButton href={socialMediaLinks.instagram} Icon={FaInstagram} />
            <SocialIconButton href={socialMediaLinks.github} Icon={FaGithub} />
            <SocialIconButton href={socialMediaLinks.stack} Icon={FaStackOverflow} />
          </div>
        </div>
      )}

      {/* Haupt-Footer */}
      <div>
        <footer
          ref={footerRef}
          className="py-10 text-gray-700 bg-gradient-to-br from-gray-50 via-white to-gray-100 text-xs sm:text-xs font-mono shadow-inner"
        >
          <div className="container mx-auto px-4 flex flex-col md:flex-row md:justify-between md:items-start md:space-x-12 text-center md:text-left">
            {/* Spalte 1 */}
            <div className="md:w-1/4">
              <div className="text-xs font-bold font-mono">Denis Bitter</div>
              <div className="text-xs mb-4">Software Architect & Full-Stack Engineering Instructor<br />
<br />
               Ich entwickle Software<br /> und lehre wie man Sie nutzt<br />
</div>
           
             
              <div className="mb-1"></div>
              <div className="text-xs text-gray-800 space-y-1">
                <p>
                  <a href={`mailto:${contactInfo.email}`} className="hover:text-black hover:underline flex items-center justify-center md:justify-start">
                    <FaEnvelope className="inline mr-2" /> {contactInfo.email}
                  </a>
                </p>
                <p>
                  <a href={`tel:${contactInfo.phone.replace(/\s/g, "")}`} className="hover:text-black hover:underline flex items-center justify-center md:justify-start">
                    <FaPhoneAlt className="inline mr-2" /> {contactInfo.phone}
                  </a>
                </p>
                <p>{contactInfo.address}</p>
              </div>
            </div>
            {/* Spalte 2 */}
            <div className="md:w-1/4 mt-8 md:mt-0">
              <h3 className="font-semibold text-gray-800 mb-4">Cockpit:</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/contact" className="hover:text-black hover:underline">
                    Sag Hallo
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={e => { e.preventDefault(); onShowCookieSettings(); }}
                    className="hover:underline hover:text-black"
                  >
                    Cookie-Einstellungen
                  </a>
                </li>
                <li>
                  <Link to="/datenschutz" className="hover:text-black hover:underline">
                    Datenschutz
                  </Link>
                </li>
                <li>
                  <Link to="/impressum" className="hover:text-black hover:underline">
                    Impressum
                  </Link>
                </li>
              </ul>
            </div>
            {/* Spalte 3 */}
                              <div className="md:w-1/4 mt-8 md:mt-0">
                              <h3 className="font-semibold text-gray-800 mb-4">ZenDev:</h3>
                  <ul className="space-y-2">
                    {useZenTitles().map((zen) => (
                      <p key={zen.slug}>
                        <Link to={`/zen/${zen.slug}`} className="hover:text-black hover:underline">
                          {truncateTitle(zen.title, 40)}
                        </Link>
                      </p>
                    ))}
                  </ul>

            </div>

                  {/* Spalte 4 – CaseStudy */}
<div className="md:w-1/4 mt-8 md:mt-0">
  <h3 className="font-semibold text-gray-800 mb-4">CaseStudy:</h3>
  <ul className="space-y-2">
    {useCaseTitles().map((c) => (
      <li key={c.slug}>
        <Link
          to={`/casestudy/${c.slug}`}
          className="hover:text-black hover:underline"
        >
          {truncateTitle(c.title, 40)}
        </Link>
      </li>
    ))}
  </ul>
</div>
            {/* Spalte 5 */}
            <div className="md:w-1/4 mt-8 md:mt-0">
              <h3 className="font-semibold text-gray-800 mb-4">Wissen Blog:</h3>
              <BlogPreviewList />
            </div>
          </div>

          <div className="container mx-auto px-4 mt-8 flex flex-col items-center md:flex-row md:justify-between text-gray-600 text-sm">
            <p className="text-center md:text-left font-mono text-xs text-gray-500">
              {copyrightText}
            </p>
            <ScrollToTopButton scrollToTop={scrollToTop} />
          </div>
        </footer>
      </div>



      {/* CookieModal: eingebunden mit Ref, und Close */}
      {showCookieModal && (
        <CookieModal
          ref={cookieModalRef}
          onClose={onCloseCookieSettings}
        />
      )}
    </>
  );
}

export default Footer;
